import React, { useState, useEffect, useContext } from 'react'
import { useTranslation } from 'react-i18next';

import { mainContext } from '../../../MainContext';

function ContainerLink() {
  const { t } = useTranslation();

  const getLink = useContext(mainContext).getLink;

  useEffect(() => {
  }, [])


  return (
    <div className="mt-4 mb-4 ms-auto me-auto text-center">
      <a href={getLink} target="_blank">
        <img src={t('getBtn')} className="w-100" alt="無料で受け取る" />
      </a>
    </div>
  );
}

export default ContainerLink;